import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c78c539"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame video" }
const _hoisted_2 = ["src"]

import { store } from '@/store/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPopup',
  setup(__props) {

const Store = store();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-popup", { open: _unref(Store).getVideoPopupOpen.length }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(Store).openVideoPopup('')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", {
        src: `https://www.youtube.com/embed/${_unref(Store).getVideoPopupOpen}?si=-qu1GCxAnjGaEh2T`,
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: ""
      }, null, 8, _hoisted_2)
    ])
  ], 2))
}
}

})